<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Internal Asset Transfer</v-toolbar-title>
    <v-spacer/>
    <span class="white--text caption font-weight-normal mr-3">Transacting Currency: {{Currency[0].CurrencyName}}</span>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>  </v-toolbar>
  </v-card>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="create">
    <v-card class="pt-3 mt-2" elevation="12">
      <v-row class="ml-1 mr-1">
        <v-col class="pb-0">
          <v-select
            outlined dense @change="getAccounts(AssetTransferEquity.CustodialID)"
            v-model="AssetTransferEquity.CustodialID"
            :items="DealCustodians"
            item-text="CustodianName"
            item-value="CustodianID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Custodian"
          ></v-select>
        </v-col>
        <v-col class="pb-0">
        </v-col>
      </v-row>
      <v-row class="ml-1 mr-1">
        <v-col class="pb-0">
          <v-select
            @change="getCurrentSellerAccountBalance(AssetTransferEquity); getAccHoldingUnits(AssetTransferEquity)"
            v-model="AssetTransferEquity.SellerAccountId"
            :items="Accounts"
            item-text="AccountName"
            item-value="AccountID"
            outlined dense
            label="Selling Account"
            placeholder="----"
          ></v-select>
          <v-row>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                :value="SellerBalances.Available != null? Number(SellerBalances.Available).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Seller Available Balance"
                readonly class="pb-0"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                :value="SellerBalances.Actual != null? (Number(SellerBalances.Actual) + Number(TotalValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Seller Actual Balance"
                readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-text-field
            :value="currentSystemDate.DayDate"
            label="Sale Date"
            append-icon="mdi-calendar-month"
            readonly placeholder="--/--/--"
            dense outlined color="#2A353D"
            :rules="TextFieldRules"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </v-col>


        <v-col class="pb-0">
          <v-select
            @change="getCurrentBuyerAccountBalance(AssetTransferEquity)"
            v-model="AssetTransferEquity.BuyerAccountId"
            :items="Accounts"
            item-text="AccountName"
            item-value="AccountID"
            outlined dense
            label="Buying Account"
            placeholder="----"
          ></v-select>
          <v-row>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                :value="BuyerBalances.Available != null? Number(BuyerBalances.Available).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Buyer Available Balance"
                readonly class="pb-0"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                :value="BuyerBalances.Actual != null? (Number(BuyerBalances.Actual) - Number(TotalValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Buyer Actual Balance"
                readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="ml-1 mr-1">
        <v-col class="pb-0 pt-0">
          <v-select
            @change="getAccHoldingUnits(AssetTransferEquity)"
            outlined dense
            v-model="AssetTransferEquity.InstrumentID"
            :items="allCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="EquityCode"
            item-value="EquityID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Instrument"
          ></v-select>
        </v-col>
        <v-col class="pb-0 pt-0">
          <v-text-field
            outlined dense 
            label="Current Holiding"
            :value="Number(HoldingUnits).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})"
            readonly placeholder="----"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ml-1 mr-1">
        <v-col class="pb-0 pt-0">
          <v-text-field
            light dense outlined
            color="#2A353D"
            v-model="AssetTransferEquity.Quantity"
            label="Quantity"
            required
            type="number"
            :rules="QuantityRules"
            placeholder="----"
          ></v-text-field>
        </v-col>
        <v-col class="pb-0 pt-0">
          <v-text-field
            light dense outlined
            v-model="AssetTransferEquity.UnitPrice"
            color="#2A353D"
            label="Unit Price"
            type="number"
            placeholder="----"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
        </v-col>
        <v-col class="pb-0 pt-0">
          <v-text-field
            light dense outlined
            color="#2A353D"
            :value="AssetTransferEquity.Quantity != null && AssetTransferEquity.UnitPrice != null? Number(getTotalValue(AssetTransferEquity)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
            label="Total Value"
            readonly placeholder="----"
            :rules="[v => TotalValue <=  BuyerBalances.Actual || 'Amount exceeds buying account balance',]"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right pt-7 mb-4 mr-3">
          <v-btn class="white--text mr-4" small color="#2A353D" @click="closeCreate()">close</v-btn>
          <v-btn class="white--text" small color="#2A353D" :disabled="!valid" @click="createNew()">
            <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
            submit
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-form>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="edit" >
    <span class="d-flex flex-row mt-2">
      <span class="grey--text caption font-weight-normal">REFERENCE: <span class="subtitle-2">{{currentAssetTransferEquity.DealNumber}}</span></span>
      <v-spacer/>
      <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentAssetTransferEquity.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span v-if="currentAssetTransferEquity.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentAssetTransferEquity.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentAssetTransferEquity.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
    </span>

    <v-card class="pt-3 mt-2" elevation="12">
      <v-row class="ml-1 mr-1">
        <v-col class="pb-0">
          <v-select
            outlined dense @change="getAccounts(currentAssetTransferEquity.CustodialID)"
            v-model="currentAssetTransferEquity.CustodialID"
            :items="DealCustodians"
            item-text="CustodianName"
            item-value="CustodianID"
            :readonly="view"
            placeholder="----"
            :rules="TextFieldRules"
            label="Custodian"
          ></v-select>
        </v-col>
        <v-col class="pb-0">
        </v-col>
      </v-row>
      <v-row class="ml-1 mr-1">
        <v-col class="pb-0">
          <v-select
            @change="getCurrentSellerAccountBalance(currentAssetTransferEquity); getAccHoldingUnits(currentAssetTransferEquity)"
            v-model="currentAssetTransferEquity.SellerAccountId"
            :items="Accounts"
            item-text="AccountName"
            item-value="AccountID"
            :readonly="view"
            outlined dense
            label="Selling Account"
            placeholder="----"
          ></v-select>
          <v-row>
            <v-col class="pb-0 pt-0">
              <v-text-field v-if="!view"
                light dense outlined
                :value="SellerBalances.Available != null? Number(SellerBalances.Available).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Seller Available Balance"
                readonly class="pb-0"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
              <v-text-field v-else
                light dense outlined
                :value="Number(currentAssetTransferEquity.SellerOpBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                color="#2A353D"
                label="Seller Opening Balance"
                readonly class="pb-0"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field v-if="!view"
                light dense outlined
                :value="SellerBalances.Actual != null? (Number(SellerBalances.Actual) + Number(TotalValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Seller Actual Balance"
                readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
              <v-text-field v-else
                light dense outlined
                :value="Number(currentAssetTransferEquity.SellerClBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                color="#2A353D"
                label="Seller Closing Balance"
                readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-text-field
            v-model="currentAssetTransferEquity.TransferDate"
            label="Sale Date"
            append-icon="mdi-calendar-month"
            readonly placeholder="--/--/--"
            dense outlined color="#2A353D"
            :rules="TextFieldRules"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </v-col>


        <v-col class="pb-0">
          <v-select
            @change="getCurrentBuyerAccountBalance(currentAssetTransferEquity)"
            v-model="currentAssetTransferEquity.BuyerAccountId"
            :items="Accounts"
            item-text="AccountName"
            item-value="AccountID"
            outlined dense
            :readonly="view"
            label="Buying Account"
            placeholder="----"
          ></v-select>
          <v-row>
            <v-col class="pb-0 pt-0">
              <v-text-field v-if="!view"
                light dense outlined
                :value="BuyerBalances.Available != null? Number(BuyerBalances.Available).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Buyer Available Balance"
                readonly class="pb-0"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
              <v-text-field v-else
                light dense outlined
                :value="Number(currentAssetTransferEquity.BuyerOpBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                color="#2A353D"
                label="Buyer Opening Balance"
                readonly class="pb-0"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field v-if="!view"
                light dense outlined
                :value="BuyerBalances.Actual != null? (Number(BuyerBalances.Actual) - Number(TotalValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Buyer Actual Balance"
                readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
              <v-text-field v-else
                light dense outlined
                :value="Number(currentAssetTransferEquity.BuyerClBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                color="#2A353D"
                label="Buyer Closing Balance"
                readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="ml-1 mr-1">
        <v-col class="pb-0 pt-0">
          <v-select
            @change="getAccHoldingUnits(currentAssetTransferEquity)"
            outlined dense
            v-model="currentAssetTransferEquity.InstrumentID"
            :items="allCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="EquityCode"
            item-value="EquityID"
            placeholder="----"
            :readonly="view"
            :rules="TextFieldRules"
            label="Instrument"
          ></v-select>
        </v-col>
        <v-col class="pb-0 pt-0">
          <v-text-field
            outlined dense
            label="Current Holiding"
            :value="view ? '' : Number(HoldingUnits).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})"
            readonly placeholder="----"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ml-1 mr-1">
        <v-col class="pb-0 pt-0">
          <v-text-field
            light dense outlined
            color="#2A353D"
            v-model="currentAssetTransferEquity.Quantity"
            label="Quantity"
            required
            type="number"
            :readonly="view"
            :rules="view ? '' : QuantityRules"
            placeholder="----"
          ></v-text-field>
        </v-col>
        <v-col class="pb-0 pt-0">
          <v-text-field
            light dense outlined
            v-model="currentAssetTransferEquity.UnitPrice"
            color="#2A353D"
            label="Unit Price"
            type="number"
            placeholder="----"
            :readonly="view"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
        </v-col>
        <v-col class="pb-0 pt-0">
          <v-text-field
            light dense outlined
            color="#2A353D"
            :value="currentAssetTransferEquity.Quantity != null && currentAssetTransferEquity.UnitPrice != null? Number(getTotalValue(currentAssetTransferEquity)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
            label="Total Value"
            readonly placeholder="----"
            :rules="view ? [] : [v => TotalValue <=  BuyerBalances.Actual || 'Amount exceeds buying account balance',]"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right pt-7 mb-4 mr-3">
          <v-btn class="white--text" small color="#2A353D" @click="view = false, closeEdit()">close</v-btn>
          <v-btn class="white--text ml-4" v-if="!view" small color="#2A353D" :disabled="!valid" @click="update()">
            <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
            save
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-form>

<!-- ********************************************************************************************TABLE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    :headers="headers"
    :fixed-header="true"
    :items="confirmedAssetTypesEquity ? allAssetTransfersEquity : allAssetTransfersEquity.filter(a => a.CheckerID === 0)"
    :search="search" v-if="!create &&  !edit"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >

      <v-dialog persistent v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus(false); close()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                ok
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="reverseDialog" max-width="350px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text text-center ma-4 mx-6">Are you sure you want to REVERSE selection?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="reverseDialog = false">no</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" @click="reverseItem()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                yes
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container row>
        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedAssetTypesEquity" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-show="confirmedAssetTypesEquity" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Internal Asset Transfers.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Internal Asset Transfers.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-show="confirmedAssetTypesEquity" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency); getCustodians()">

          <v-list-item-title>
            {{ Currency.CurrencyName }}
          </v-list-item-title>

          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-show="!confirmedAssetTypesEquity" @click="confirmedAssetTypesEquity = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0 && item.IsReversed == 0">rejected</v-chip>
      <v-chip outlined small color="error" v-if="item.IsReversed == 1">reversed</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0 && item.IsReversed == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0 && item.IsReversed == 0">confirmed</v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedAssetTypesEquity && item.CheckerID == 0" top>

      </v-tooltip>
      <v-tooltip v-if="!confirmedAssetTypesEquity && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveAssetTransferEquity(item, index); updateStatus(true)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedAssetTypesEquity && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="reject(); setActiveAssetTransferEquity(item, index)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedAssetTypesEquity"
        small outlined v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="TotalValue = item.Quantity * item.UnitPrice; setActiveAssetTransferEquity(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        @click="view = true; setActiveAssetTransferEquity(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-show="confirmedAssetTypesEquity"
            v-on="on"
            :disabled="showReverseBtn == true && item.CheckerID == 0 ? false : true"
            color="#2A353D" @click="setActiveAssetTransferEquity(item, index); reverseDialog = true"
          >
          mdi-backup-restore
          </v-icon>
        </template>
        <span>reverse</span>
      </v-tooltip>
    </template>

    <template v-slot:item.SellerAccountId="{ item }">
      {{allClientAccounts.filter(a => a.AccountID == item.SellerAccountId).map(a => a.tblclient.MajorName)[0]}}
    </template>

    <template v-slot:item.BuyerAccountId="{ item }">
      {{allClientAccounts.filter(a => a.AccountID == item.BuyerAccountId).map(a => a.tblclient.MajorName)[0]}}
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import dealingService from '../services/dealing.service';
import transactionService from '../services/transaction.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      confirmedAssetTypesEquity: true,
      edit: false,
      create:false,
      view: false,
      message: '',
      menu: false,
      menu_1: false,
      menu_2: false,
      dialog: false,
      permitted: null,
      permitted_dialog: true,
      reverseDialog: false,
      loading: false,
      search: '',
      valid: true,
      currentAssetTransferEquity: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Ref Number',
          align: 'start',
          sortable: true,
          value: 'DealNumber'
        },
        { text: 'Seller', value: 'SellerAccountId', sortable: false },
        { text: 'Buyer', value: 'BuyerAccountId', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      QuantityRules: [
        v => !!v || 'field is required',
        v => (!!v && v <= this.HoldingUnits) || 'Value exceeds Units Held',
      ],
      CreateDateRules: [
        v => !!v || 'field is required',
        v => (v <= this.currentSystemDate.DayDate) || 'Date must not exceed Purchase Date'
      ],
      EditDateRules: [
        v => !!v || 'field is required',
        v => (v <= this.currentAssetTransferEquity.PurchaseDate) || 'Date must not exceed Purchase Date'
      ],
      SellerBalances: {},
      BuyerBalances: {},
      CurrencyId: 0,
      Accounts: [],
      DealCustodians: [],
      UnitPrice: 0,
      TotalValue: 0,
      HoldingUnits: 0,
      RejectionStatus: 0,
      AssetTransferEquity: {},
      errors: [],
    }
  },

  computed: {
    ...mapGetters([
      "allAssetTransfersEquity",
      "allCurrencies",
      "allAssetTypes",
      "allRejectionReasons",
      "allCounters",
      "allUnlistedCounters",
      "allCounterparties",
      "allClientAccounts",
      "allDealers",
      "allUsers",
      "allTransactionCharges",
      "allTaxes",
      "currentSystemDate",
      "allApplicationDefaults",
      "allConfirmationSettings"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },
    AssetTransfersEquity() {
      return this.allAssetTransfersEquity.filter(a => a.CurrencyID == this.CurrencyId);
    },
    Currency() {
      return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
    },
    DealerID() {
      return this.allDealers.filter(a => a.SystemUserID == this.currentUser.SecurityUserID).map(a => a.DealerID).toLocaleString();
    },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3023).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3023).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3023).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 3023).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  watch: {
    // TotalValue: function(newValue) {
    //   this.getTaxes(newValue);
    //   this.getCharges(newValue)
    // },
    // ConfirmationDate: function(newValue) {
    //   if(newValue != null && newValue != ''){
    //     var data = {
    //       Date: newValue,
    //     };

    //     dealingService.checkIsWeekendHoliday(data)
    //     .then(response => {
    //       this.errors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
    //     })        
    //   }
    // },
    'currentAssetTransferEquity.TransferID': {
      handler: function() {
        // this.currentAssetTransferEquity.Quantity = Number(this.currentAssetTransferEquity.Quantity.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}))

        if (this.currentAssetTransferEquity.InstrumentID >= 9000){
          this.ListedCounters = false
        }

        this.Taxable = !!this.currentAssetTransferEquity.IsTaxable
        this.ConfirmationDate = this.currentAssetTransferEquity.DealConfirmationDate

        if(this.view != true){
          for (let i = 0; i < this.currentAssetTransferEquity.allocations.length; i++) {
            this.getCurrentAccountBalance(this.currentAssetTransferEquity.allocations[i])
          }
        }

        // for (let t = 0; t < this.currentAssetTransferEquity.allocations.length; t++) {
        //   this.currentAssetTransferEquity.allocations[t].Quantity = Number(this.currentAssetTransferEquity.allocations[t].Quantity.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}))
        // }
      },
      deep: true
    }
  },

  created () {
    this.CurrencyId = this.allApplicationDefaults[0].CurrencyID
    this.getCustodians();
  },

  methods: {
    ...mapActions([
      "createAssetTransferEquity",
      "updateAssetTransferEquity",
      "deleteAssetTransferEquity",
    ]),

     async createNew() {
      this.message = '';

      await this.validate()

      if (this.valid == true) {
        this.loading = true;
        this.AssetTransferEquity.MakerID = this.currentUser.SecurityUserID,
        this.AssetTransferEquity.CheckerID = this.CheckerID,
        this.AssetTransferEquity.CurrencyID = this.CurrencyId,
        this.AssetTransferEquity.DealerID = this.DealerID,
        this.AssetTransferEquity.TransferDate = this.currentSystemDate.DayDate,
        this.AssetTransferEquity.LastUserID = this.currentUser.SecurityUserID,
        this.AssetTransferEquity.AssetType = 2,
        this.AssetTransferEquity.SellerOpBalance = this.SellerBalances.Actual,
        this.AssetTransferEquity.BuyerOpBalance = this.BuyerBalances.Actual,
        this.AssetTransferEquity.SellerClBalance = Number(this.SellerBalances.Actual) + Number(this.TotalValue),
        this.AssetTransferEquity.BuyerClBalance = Number(this.BuyerBalances.Actual) - Number(this.TotalValue),

        this.createAssetTransferEquity(this.AssetTransferEquity)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'newAssetTransferEquity',
            data: response.data
          });
          this.message = response.data.message
          this.loading = false;
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        }) 
      }
    },

    async update() {
      this.message = '';

      await this.validate()

      if (this.valid == true) {
        this.loading = true;
        this.currentAssetTransferEquity.SellerOpBalance = this.SellerBalances.Actual,
        this.currentAssetTransferEquity.BuyerOpBalance = this.BuyerBalances.Actual,
        this.currentAssetTransferEquity.SellerClBalance = Number(this.SellerBalances.Actual) + Number(this.TotalValue),
        this.currentAssetTransferEquity.BuyerClBalance = Number(this.BuyerBalances.Actual) - Number(this.TotalValue),
        this.currentAssetTransferEquity.CurrencyID = this.CurrencyId,
        this.currentAssetTransferEquity.DealerID = this.DealerID,
        this.currentAssetTransferEquity.MakerID = this.currentUser.SecurityUserID,
        this.currentAssetTransferEquity.LastUserID = this.currentUser.SecurityUserID,
        this.currentAssetTransferEquity.CheckerID = 0,
        this.currentAssetTransferEquity.CheckDate = null,
        this.currentAssetTransferEquity.MakeDate = new Date(),
        this.currentAssetTransferEquity.RejectionID = this.RejectionStatus,

        this.updateAssetTransferEquity(this.currentAssetTransferEquity)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updAssetTransferEquity',
            data: this.currentAssetTransferEquity
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    updateStatus(status) {
      this.message = '';
      this.loading = true;

      this.currentAssetTransferEquity.CheckerID = this.currentUser.SecurityUserID,
      this.currentAssetTransferEquity.LastUserID = this.currentUser.SecurityUserID,
      this.currentAssetTransferEquity.CheckDate = new Date(),
      this.currentAssetTransferEquity.updatedAt = new Date(),
      this.currentAssetTransferEquity.RejectionID = this.RejectionStatus,
      this.currentAssetTransferEquity.IsConfirmation = status,

      this.updateAssetTransferEquity(this.currentAssetTransferEquity)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updAssetTransferEquity',
          data: this.currentAssetTransferEquity
        });
        
        this.message = response.data.message
        this.loading = false;
        this.closeEdit()
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false;
      })
    },

    reverseItem() {
      this.message = '';
      this.loading = true;

      this.currentAssetTransferEquity.CheckerID = this.currentUser.SecurityUserID,
      this.currentAssetTransferEquity.LastUserID = this.currentUser.SecurityUserID,
      this.currentAssetTransferEquity.CheckDate = new Date(),
      this.currentAssetTransferEquity.updatedAt = new Date(),
      this.currentAssetTransferEquity.RejectionID = this.RejectionStatus,
      this.currentAssetTransferEquity.IsReversed = true,

      this.updateAssetTransferEquity(this.currentAssetTransferEquity)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updAssetTransferEquity',
          data: this.currentAssetTransferEquity
        });
        
        this.message = response.data.message
        this.loading = false;
        this.reverseDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false;
        this.reverseDialog = false
      })
    },

    getCustodians() {
      this.message = '';
      var data ={
        CurrencyID: this.CurrencyId,
      }
      dealingService.getCustodians(data.CurrencyID)
      .then(response => {
        this.DealCustodians = response.data
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    // getSellerBalances(item) {
    //   this.message = '';
    //   var data ={
    //     CustodialID: item,
    //     CurrencyID: this.CurrencyId
    //   }
    //   dealingService.getBalances(data.CustodialID, data)
    //   .then(response => {
    //     this.SellerBalances = response.data[0]
    //   },
    //   error => {
    //   this.message =
    //     (error.response && error.response.data.message) ||
    //     error.message ||
    //     error.toString();
    //   })
    // },

    // getBuyerBalances(item) {
    //   this.message = '';
    //   var data ={
    //     CustodialID: item,
    //     CurrencyID: this.CurrencyId
    //   }
    //   dealingService.getBalances(data.CustodialID, data)
    //   .then(response => {
    //     this.BuyerBalances = response.data[0]
    //   },
    //   error => {
    //   this.message =
    //     (error.response && error.response.data.message) ||
    //     error.message ||
    //     error.toString();
    //   })
    // },

    getCurrentSellerAccountBalance(item) {
      this.message = '';
      var data ={
        AccountID: item.SellerAccountId,
        EffectiveDate: this.currentSystemDate.DayDate
      }

      if (item.SellerAccountId != null) {
        transactionService.getAccountBalances(data.AccountID, data)
        .then(response => {
          this.SellerBalances = response.data[0]
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getCurrentBuyerAccountBalance(item) {
      this.message = '';
      var data ={
        AccountID: item.BuyerAccountId,
        EffectiveDate: this.currentSystemDate.DayDate
      }

      if (item.BuyerAccountId != null) {
        transactionService.getAccountBalances(data.AccountID, data)
        .then(response => {
          this.BuyerBalances = response.data[0]
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getAccHoldingUnits(item) {
      var data = {
        AccountID: item.SellerAccountId,
        InstrumentID: item.InstrumentID,
        EffectiveDate: this.currentSystemDate.DayDate,
        AssetType: 2
      }
      if (item.SellerAccountId != null && item.InstrumentID != null) {
        dealingService.getAccountHolding(data)
        .then(response => {
          this.HoldingUnits = Number(response.data.map(r => r.UnitsHeld)[0])
          return this.HoldingUnits
        })
      }
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Internal Asset Transfers", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Internal Asset Transfers.pdf')
      }
    },

    getClosingBalance(item) {
      item.ClosingBalance = Number(item.OpeningBalance) - item.AllocationValue;
      return item.ClosingBalance
    },

    getUnitPrice(parent) {
      this.UnitPrice = parent.InstrumentValue / parent.Quantity
      return this.UnitPrice
    },

    getAllocationUnitPrice(item, parent) {
      item.UnitPrice = parent.UnitPrice
      return item.UnitPrice
    },

    getAllocationValue(item) {
      item.AllocationValue = item.Quantity * item.UnitPrice;
      return item.AllocationValue
    },

    getAllocationChargeValue(item, parent) {
      item.ChargeValue = (item.Quantity / parent.Quantity) * (this.getTotalCharges() + this.getTotalVAT());
      return item.ChargeValue
    },

    getTotalCharges() {
      return this.ChargesApplied.map(a => Number(a.Charge)).reduce((a, b) => a + b, 0)
    },

    getTotalVAT() {
      return this.TaxesApplied.map(a => Number(a.Amount)).reduce((a, b) => a + b, 0)
    },

    retrieveSettlementDetails(item) {
      var data = {
        DealDate: item,
        Listed: !!this.ListedCounters,
        Days: this.SettlementDays
      }
      if (data.DealDate != null && data.Listed != null && data.Days != null) {
        dealingService.getSettlementDetails(data)
        .then(response => {
          this.SettlementDays = response.data[0].fnDaysToSettlement
          this.SettlementDate = response.data[0].fnSettlementDate
        })
      }
    },

    mapCurrency(currency) {
      return this.CurrencyId = currency.CurrencyID
    },

    allowedDates: val => val <= new Date().toISOString().split('T')[0],

    getCustodianName(id) {
      return this.DealCustodians.filter(a => a.CustodianID === id).map(a => a.CustodianName).toLocaleString()
    },

    getTotalValue(item) {
      this.TotalValue = item.Quantity * item.UnitPrice
      return this.TotalValue
    },

    getNetConsideration(item) {
      item.InstrumentValue = this.TotalValue + this.getTotalCharges() + this.getTotalVAT()
      return item.InstrumentValue
    },

    getAllocatedValue(item) {
      return item.map(i => Number(i.AllocationValue)).reduce((a, b) => a + b, 0);
    },

    getAllocatedUnits(item) {
      return item.map(i => Number(i.Quantity)).reduce((a, b) => a + b, 0);
    },

    getAccounts(item) {
      var data = {
        CustodialID: item,
        CurrencyID: this.CurrencyId,
        Taxable: null,
        Counter: 0
      }
      dealingService.getCustodianAccounts(data.CustodialID, data)
      .then(response => {
        this.Accounts = response.data
      })
    },

    NewAllocation(item) {
      item.push(
        {
          AccountID: null,
          OpeningBalance: '',
          AllocationValue: '',
          ChargeValue: '',
          Quantity: '',
          UnitPrice: '',
          ClosingBalance: ''
        }
      )
    },

    removeAllocation(item, parent) {
      const index = parent.findIndex(p => p.AccountID === item.AccountID);
      parent.splice(index, 1)
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedAssetTypesEquity = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.SellerBalances = {},
      this.BuyerBalances = {},
      this.Accounts = [],
      this.TotalValue = 0,
      this.edit = false
    },

    showCreate () {
      this.create = true;
      this.retrieveSettlementDetails(this.currentSystemDate.DayDate)
    },

    closeCreate() {
      this.SellerBalances = {},
      this.BuyerBalances = {},
      this.Accounts = [],
      this.AssetTransferEquity = {},
      this.TotalValue = 0,
      this.create = false
    },

    reject () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.RejectionStatus = 0
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },

    setActiveAssetTransferEquity (item, index) {
      this.currentAssetTransferEquity = item
      this.currentIndex = index

      this.getAccounts(item.CustodialID)
      this.getCurrentSellerAccountBalance(item)
      this.getCurrentBuyerAccountBalance(item)
      this.getAccHoldingUnits(item)
    },

    async setActiveAllocation (item, index) {
      this.currentAllocation = item
      this.allocationIndex = index
    },
  },

  mounted () {
    UserService.isInternalAssetTransfer().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedAssetTransfers", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.edit {
  background-color: #DBEFFA;
}

.v-btn {
  outline: none
}

/* .v-select__selections input {
  display: none;
} */

.Account {
  width: 300px;
}

.my-allocations-table{
  table-layout : fixed;
}

.table-text-field{
  width: 170px;
}

.headline {
  color:white
}
</style>
